class InitFaq {
    constructor() {

        var $set = $('#searchresults');

        var $errormsg = $('.error', $set);

        $('.faq--searchfield').on('keyup change', _.debounce(function () {
            var value = $(this).val().toLowerCase();
            if (value.length < 4) {
                $set.hide();
                return;
            };

            var keywords = value.split(' ');
            var numInSet = 0;

            $.each($set.find('.accordion > li[data-question]'), function (idx, question) {

                var $q = $(question),
                    q = $q.data('question'),
                    a = $q.data('answer');

                if (q === undefined) return;

                var found = false;
                var matching = 0;

                $.each(keywords, function (mid, keyword) {
                    if (keyword.length < 4) return;

                   var exactpattern = new RegExp("(\\b" + keyword + "\\b)", "gim");
                   var paritalpattern = new RegExp("(" + keyword + ")", "gim");

                    // check question (exact word)
                    q = q.replace(exactpattern, function (match) {
                        matching = matching + 20;
                        found = true;
                        return "";
                    });
                    // check in question (partial word)
                    q = q.replace(paritalpattern, function (match) {
                        matching = matching + 5;
                        found = true;
                        return "";
                    });
                    // check in answer (exact word)
                    a = a.replace(exactpattern, function (match) {
                        matching = matching + 10;
                        found = true;
                        return "";
                    });
                    // check in answer (partial word)
                    a = a.replace(paritalpattern, function (match) {
                        matching = matching + 3;
                        found = true;
                        return "";
                    });

                });
                $q.data('matching', matching);

                if (found) {
                    var src_str = $q.find('.content').html();
                    if ($q.data('org_content') !== undefined) {
                        src_str = $q.data('org_content');
                    }
                    $q.data('org_content', src_str);
                    $.each(keywords, function (mid, keyword) {
                        if (keyword.length < 4) return;
                        keyword = keyword.replace(/(\s+)/, "(<[^>]+>)*$1(<[^>]+>)*");
                        var pattern = new RegExp("(" + keyword + ")", "gi");
                        src_str = src_str.replace(pattern, "<mark>$1</mark>");
                        src_str = src_str.replace(/(<mark>[^<>]*)((<[^>]+>)+)([^<>]*<\/mark>)/, "$1</mark>$2<mark>$4");
                    });
                    $q.find('.content').html(src_str);
                }

                if (found) {
                    numInSet++;
                    $q.show();
                } else {
                    $q.hide();
                }
            });
            if (numInSet < 1) {
                $errormsg.show();
                $set.show();
            } else {
                $errormsg.hide();

                // sort results
                $set.find('.accordion > li[data-question]').sort(sort_li).appendTo('#searchresults .accordion');

                $set.show();
            }

        }, 400));
        $('.faq--searchfield').trigger('change');

        // sort function callback
        function sort_li(a, b) {
            return ($(b).data('matching')) < ($(a).data('matching')) ? -1 : 1;
        }
    }
}

export default new InitFaq();
